import { APP_INITIALIZER, Provider } from '@angular/core';
import { TranslocoService } from '@jsverse/transloco';
import { forkJoin } from 'rxjs';

/**
 * Preloads all available languages on app initialization
 * This ensures all translations are available immediately,
 * preventing race conditions with lazy-loaded components
 */
export function preloadTranslations(translocoService: TranslocoService) {
  return () => {
    const availableLangs = ['en', 'es', 'pt', 'fr', 'de'];
    
    // Load all languages in parallel
    return forkJoin(
      availableLangs.map(lang => translocoService.load(lang))
    );
  };
}

/**
 * Provider for preloading all translations during app initialization
 */
export const PRELOAD_TRANSLATIONS_PROVIDER: Provider = {
  provide: APP_INITIALIZER,
  useFactory: preloadTranslations,
  deps: [TranslocoService],
  multi: true,
};

